import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {isSession} from "../util-components/Session/Session";
import {AUTH_PREFIX_PATH} from "../../configs/AppConfig";

const PrivateRoute = ({component: Component, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            isSession() ?
                <Component {...props} />
                : <Redirect to={AUTH_PREFIX_PATH+"/login"} />
        )} />
    );
};

export default PrivateRoute;